module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "hrms13x-detail"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left"
  }, [_vm._v(_vm._s(_vm.labels['HRPM81X2']['10']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-100"
  }, [_vm._v(_vm._s(_vm.indexSelected.codempid) + " - " + _vm._s(_vm.indexSelected.desc_codempid))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-tab"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('detail-tab1', {
    attrs: {
      "labels": _vm.labels,
      "data": _vm.detail.tab1
    }
  }), _vm._v(" "), _c('detail-tab2', {
    attrs: {
      "labels": _vm.labels,
      "data": _vm.detail.tab2,
      "tab2Table": _vm.tab2Table
    }
  }), _vm._v(" "), _c('detail-tab3', {
    attrs: {
      "labels": _vm.labels,
      "data": _vm.detail.tab3,
      "tab3Table1": _vm.tab3Table1,
      "tab3Table2": _vm.tab3Table2
    }
  }), _vm._v(" "), _c('detail-tab4', {
    attrs: {
      "labels": _vm.labels,
      "data": _vm.detail.tab4,
      "tab4Table": _vm.tab4Table
    }
  }), _vm._v(" "), _c('detail-tab5', {
    attrs: {
      "labels": _vm.labels,
      "data": _vm.detail.tab5,
      "indexSelected": _vm.indexSelected,
      "nowLang": _vm.nowLang
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.toggle('index')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5b7a3611!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms13x/detail.vue
// module id = 3796
// module chunks = 1